import { Divider, Drawer, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';
import styles from './styles';
import { SidebarProps } from './types';
import { ReactComponent as Logout } from '../../assets/images/logout.svg';
import { ReactComponent as Logo } from '../../assets/images/nav-logo.svg';

const Sidebar = ({ items, handleLogout }: SidebarProps) => {
    const location = useLocation();
    return (
        <Drawer
            sx={styles.sidebar}
            variant="permanent"
            anchor="left"
            PaperProps={{
                sx: styles.paper,
            }}
        >
            <List sx={styles.list}>
                <ListItem key="logo">
                    <ListItemIcon sx={styles.icon}>
                        <Logo />
                    </ListItemIcon>
                </ListItem>
                <Divider sx={styles.divider} />
                {items.map(({ id, url, Icon, ActiveIcon, text }) => (
                    <ListItem key={id} sx={url && location.pathname.includes(url) ? styles.active : {}}>
                        {Icon ? (
                            <NavLink id={id.toString()} key={id} to={url || ''}>
                                <ListItemIcon sx={styles.icon}>
                                    {url && location.pathname.includes(url) ? (
                                        <ActiveIcon data-testid={`${text} active_icon`} />
                                    ) : (
                                        <Icon data-testid={`${text}`} />
                                    )}
                                </ListItemIcon>
                            </NavLink>
                        ) : null}
                        {text === 'Users' ? <ListItemText sx={styles.text}>{text}</ListItemText> : null}
                        {text === 'divider' ? <Divider sx={styles.divider} /> : null}
                    </ListItem>
                ))}
                <ListItem key="logout">
                    <ListItemIcon sx={styles.icon} onClick={handleLogout}>
                        <Logout />
                    </ListItemIcon>
                </ListItem>
            </List>
        </Drawer>
    );
};

export default Sidebar;
